import Footer from "./Footer/Footer";

import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { api } from "../api/axios";
import { useI18n } from "../../i18n/I18nContext";

export default function VerifyEmail() {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const { id, hash } = useParams();
  const { search } = useLocation(); 
  const navigate = useNavigate();
  const { t } = useI18n();

  useEffect(() => {
    api
      .get(`/api/v1/email/verify/${id}/${hash}${search}`)
      .then((res) => {
        setStatus("success");
        setMessage(res.data.message || t("Email verificado com sucesso."));
        setTimeout(() => navigate("/login"), 3000);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err?.response?.data?.message || t("Link inválido ou expirado."));
      });
  }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100">
            <div className="pt-20">
                {/* Hero */}
                <section className="relative overflow-hidden bg-indigo-600 text-white">
                    <div
                        className="absolute inset-0 opacity-[0.06]"
                        style={{
                            backgroundImage:
                                "repeating-linear-gradient(0deg, transparent, transparent 39px, white 39px, white 40px), repeating-linear-gradient(90deg, transparent, transparent 39px, white 39px, white 40px)",
                        }}
                    />
                    <div className="absolute bottom-0 left-0 right-0 overflow-hidden leading-none">
                        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" className="w-full h-16 fill-white">
                            <path d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z" />
                        </svg>
                    </div>

                    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-20 pb-28 text-center">
                        <span className="inline-block mb-5 rounded-full border border-white/30 bg-white/10 px-4 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-white/80">
                            {t("Conta")}
                        </span>
                        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight leading-tight mb-4">
                            {t("Verificação de Email")}
                        </h1>
                        <p className="text-lg text-indigo-100 leading-relaxed max-w-xl mx-auto">
                            {t("A confirmar o teu endereço de email e ativar a tua conta RacksForAll.")}
                        </p>
                    </div>
                </section>

                {/* Card central */}
                <section className="mx-auto max-w-lg px-4 sm:px-6 py-20">
                    {status === "loading" && (
                        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm px-10 py-14 text-center">
                            {/* Spinner */}
                            <div className="flex justify-center mb-6">
                                <div className="w-14 h-14 rounded-full border-[3px] border-gray-200 border-t-indigo-600 animate-spin" />
                            </div>
                            <h2 className="text-xl font-bold text-gray-900 mb-2">{t("A verificar…")}</h2>
                            <p className="text-sm text-gray-500 leading-relaxed">
                                {t("Aguarda enquanto confirmamos o teu email.")}
                            </p>
                        </div>
                    )}

                    {status === "success" && (
                        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm px-10 py-14 text-center">
                            {/* Check animado */}
                            <div className="flex justify-center mb-6">
                                <svg className="w-20 h-20" viewBox="0 0 52 52" fill="none">
                                    <circle
                                        cx="26" cy="26" r="24"
                                        stroke="#4f46e5"
                                        strokeWidth="2"
                                        strokeDasharray="151"
                                        strokeDashoffset="151"
                                        style={{
                                            animation: "drawCircle 0.6s cubic-bezier(0.65,0,0.45,1) 0.1s forwards"
                                        }}
                                    />
                                    <path
                                        d="M14 27l8 8 16-16"
                                        stroke="#4f46e5"
                                        strokeWidth="2.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeDasharray="32"
                                        strokeDashoffset="32"
                                        style={{
                                            animation: "drawCheck 0.4s cubic-bezier(0.65,0,0.45,1) 0.65s forwards"
                                        }}
                                    />
                                </svg>
                            </div>

                            <h2 className="text-2xl font-bold text-gray-900 mb-2">{t("Email verificado!")}</h2>
                            <p className="text-sm text-gray-500 leading-relaxed mb-8 max-w-xs mx-auto">
                                {message} {t("A tua conta está agora ativa.")}
                            </p>

                            <div className="flex flex-col sm:flex-row gap-3 justify-center">
                                <Link
                                    to="/login"
                                    className="inline-flex items-center justify-center gap-2 rounded-xl bg-indigo-600 text-white px-6 py-3 text-sm font-semibold hover:bg-indigo-700 transition"
                                >
                                    {t("Ir para o login")}
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </Link>
                                <Link
                                    to="/products"
                                    className="inline-flex items-center justify-center rounded-xl border border-gray-300 text-gray-700 px-6 py-3 text-sm font-medium hover:bg-gray-50 transition"
                                >
                                    {t("Ver produtos")}
                                </Link>
                            </div>

                            <p className="text-xs text-gray-400 mt-6">
                                {t("Redireccionado automaticamente em 5 segundos…")}
                            </p>
                        </div>
                    )}

                    {status === "error" && (
                        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm px-10 py-14 text-center">
                            {/* X icon */}
                            <div className="flex justify-center mb-6">
                                <div className="w-20 h-20 rounded-full border-2 border-gray-300 flex items-center justify-center">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round">
                                        <path d="M18 6L6 18M6 6l12 12" />
                                    </svg>
                                </div>
                            </div>

                            <h2 className="text-xl font-bold text-gray-900 mb-2">{t("Verificação falhada")}</h2>
                            <p className="text-sm text-gray-500 leading-relaxed mb-8 max-w-xs mx-auto">
                                {message}
                            </p>

                            <div className="flex flex-col sm:flex-row gap-3 justify-center">
                                <Link
                                    to="/login"
                                    className="inline-flex items-center justify-center gap-2 rounded-xl bg-indigo-600 text-white px-6 py-3 text-sm font-semibold hover:bg-indigo-700 transition"
                                >
                                    {t("Ir para o login")}
                                </Link>
                                <Link
                                    to="/"
                                    className="inline-flex items-center justify-center rounded-xl border border-gray-300 text-gray-700 px-6 py-3 text-sm font-medium hover:bg-gray-50 transition"
                                >
                                    {t("Página inicial")}
                                </Link>
                            </div>
                        </div>
                    )}
                </section>
            </div>

            {/* CSS das animações do SVG */}
            <style>{`
                @keyframes drawCircle {
                    to { stroke-dashoffset: 0; }
                }
                @keyframes drawCheck {
                    to { stroke-dashoffset: 0; }
                }
            `}</style>

            <Footer />
        </div>
    );
}